module.exports = __webpack_public_path__ + "static/media/cropped-logo-veci-beli.ff4d4fa9.png";